import { clsx } from 'clsx';
import { OverflowTooltip } from 'library/tooltip';
import { ForwardedRef, ReactNode, forwardRef } from 'react';
import Header from './Header';

interface AppHeaderProps {
    title: ReactNode;
    headerComponent?: ReactNode;
    headerActions?: ReactNode;
    ref?: ForwardedRef<HTMLElement>;
    lean?: boolean;
}

const AppHeader = forwardRef<HTMLElement, AppHeaderProps>((props, ref) => {
    const { title, headerComponent, headerActions, lean = false } = props;

    return (
        <Header
            ref={ref}
            className={clsx(
                'flex items-center gap-6 px-6 pt-6',
                lean ? 'pb-0 h-[calc(var(--header-height)-16px)]' : 'pb-4 h-[var(--header-height)]'
            )}
        >
            <div className="overflow-hidden">
                {headerComponent}

                <h3 className="mt-2">
                    <OverflowTooltip>{title}</OverflowTooltip>
                </h3>
            </div>

            {headerActions && <div className="ml-auto flex items-center gap-4">{headerActions}</div>}
        </Header>
    );
});

export default AppHeader;
